import * as React from "react";
import { Card } from "@grandvisionhq/common";
/* empty css                 */
const ProductItemLoading = ({ product, labels }) => {
  const { slug, sku } = product;
  return /* @__PURE__ */ React.createElement(Card, { key: `${slug}-${sku}`, layout: "horizontal", className: "try-in-store-modal__product-item" }, /* @__PURE__ */ React.createElement(
    Card.Image,
    {
      src: "",
      alt: labels.imageAlt,
      className: "try-in-store-modal__product-item__image"
    }
  ), /* @__PURE__ */ React.createElement(Card.Content, { center: true, className: "try-in-store-modal__product-item__content" }, /* @__PURE__ */ React.createElement(Card.Heading, { variant: "subheading1", component: "h3" }, labels.title)));
};
export {
  ProductItemLoading
};
//# sourceMappingURL=ProductItemLoading.js.map
